import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCurrentRoute } from '../../redux/reducers/utils/navReducer';

const DeliveryModule = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentRoute('delivery/map'));
    navigate('/delivery/map');
  }, []);
  
  return null;
}

export default DeliveryModule;